import { Routes } from '@angular/router';
import { DefaultLayoutComponent } from './layout';
import { AuthGuard } from './auth.guard';

import {DocumentsComponent} from './views/documents/documents.component'
import { Component } from '@angular/core';

export const routes: Routes = [
  {
    path: '',
    redirectTo: 'login',
    pathMatch: 'full',
  },
  {
    path: '',
    component: DefaultLayoutComponent,
    data: {
      title: 'Home',
    },
    // canActivate: [AuthGuard],
    children: [
      {
        path: 'merchant-config',
        loadChildren: () =>
          import('./views/merchant-config/merchant-config.routes').then((m) => m.routes),
      },
      {
        path: 'payments',
        loadChildren: () =>
          import('./views/payments/payments.routes').then((m) => m.routes),
      },
      {
        path: 'orders',
        loadChildren: () =>
          import('./views/orders/orders.routes').then((m) => m.routes),
      },
      {
        path: 'push-notifications',
        loadChildren: () =>
          import('./views/push-notifications/push-notifications.routes').then(
            (m) => m.routes
          ),
      },
      {
        path: 'voucher',
        loadChildren: () =>
          import('./views/vouchers/voucher.routes').then((m) => m.routes),
      },
      {
        path: 'banner',
        loadChildren: () =>
          import('./views/banners/banner.routes').then((m) => m.routes),
      },
      {
        path: 'refund',
        loadChildren: () =>
          import('./views/refunds/refunds.routes').then((m) => m.routes),
      },
      {
        path: 'passwords-th',
        loadChildren: () => import('./views/passwords-th/passwords-th.routes').then((m) => m.routes),
      },
      // EN-12330 : New route for displaying 'All Documents' of merchant
      {
        path: 'documents',
        children: [{
          path: 'all',
          component: DocumentsComponent
        }]
      }
    ],
  },
  {
    path: '404',
    loadComponent: () =>
      import('./views/pages/page404/page404.component').then(
        (m) => m.Page404Component
      ),
    data: {
      title: 'Page 404',
    },
  },
  {
    path: '500',
    loadComponent: () =>
      import('./views/pages/page500/page500.component').then(
        (m) => m.Page500Component
      ),
    data: {
      title: 'Page 500',
    },
  },
  {
    path: 'login',
    loadComponent: () =>
      import('./views/pages/login/login.component').then(
        (m) => m.LoginComponent
      ),
    data: {
      title: 'Login Page',
    },
  },
  {
    path: 'register',
    loadComponent: () =>
      import('./views/pages/register/register.component').then(
        (m) => m.RegisterComponent
      ),
    data: {
      title: 'Register Page',
    },
  },
  {
    path: 'forgot-password',
    loadComponent: () =>
      import('./views/pages/forgot-password/forgot-password.component').then(
        (m) => m.ForgotPasswordComponent
      ),
    data: {
      title: 'Forgot Password Page',
    },
  },
  { path: '**', redirectTo: 'payments' },
];
